(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-variants"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopMedia = window.matchMedia('(min-width: 750px)');

    const updateGridLayout = (grid) => {
      const variantCount = Number.parseInt(grid.dataset.featuredVariantsCount || '0', 10);

      if (!desktopMedia.matches || variantCount < 4) {
        grid.classList.remove('featured-variants__grid--single-row');
        return;
      }

      const gridStyles = window.getComputedStyle(grid);
      const gap = Number.parseFloat(gridStyles.getPropertyValue('--featured-variants-gap')) || 0;
      const maxCardWidth = Number.parseFloat(gridStyles.getPropertyValue('--featured-variants-max-card')) || 280;
      const requiredWidth = variantCount * maxCardWidth + Math.max(variantCount - 1, 0) * gap;

      grid.classList.toggle('featured-variants__grid--single-row', grid.clientWidth >= requiredWidth);
    };

    const initializeGrid = (grid) => {
      const resizeObserver = new ResizeObserver(() => updateGridLayout(grid));
      resizeObserver.observe(grid);
      updateGridLayout(grid);
    };

    document.querySelectorAll('[data-featured-variants-grid]').forEach(initializeGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
